module.exports = __webpack_public_path__ + "static/chirpyest-ed19fb9bfb31c917217ab3d90575bf27.svg";